module.exports = __webpack_public_path__ + "assets/construction-dark.e90baf38.svg";